import { Observable } from '../Observable';
import { mergeInternals } from './mergeInternals';
export function mergeMap(project, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return function (source) { return new Observable(function (subscriber) { return mergeInternals(source, subscriber, project, concurrent); }); };
}
//# sourceMappingURL=mergeMap.js.map